<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="cancel"
    :visible.sync="dialog"
    :title="isAdd ? '新增' : '编辑'"
    width="600px"
  >
    <essenceListenss
      ref="essenceListenss"
      @returnId="returnId"
    ></essenceListenss>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      size="small"
      label-width="100px"
    >
      <el-form-item
        label="种类:"
        prop="speciesId"
        :rules="[{ required: true, message: '种类不能为空' }]"
      >
        <el-select
          v-model="form.speciesId"
          placeholder="请选择"
          style="width: 400px"
        >
          <el-option
            v-for="item in options1"
            :key="item.id"
            :label="item.speciesName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="科目:"
        prop="subjectId"
        :rules="[{ required: true, message: '科目不能为空' }]"
      >
        <el-select
          v-model="form.subjectId"
          placeholder="请选择"
          style="width: 400px"
        >
          <el-option
            v-for="item in options3"
            :key="item.subjectId"
            :label="item.subjectName"
            :value="item.subjectId"
          ></el-option>
        </el-select>
      </el-form-item>

      <!--  -->
      <el-form-item
        label="听力精听:"
        prop="toeflHearingListId"
        :rules="[{ required: true, message: '听力精听不能为空' }]"
      >
        <span class="r" v-if="txt1 != ''"><span>中文名:</span>{{ txt1 }}</span>
        <span class="r" v-if="txt2 != ''"><span>英文名:</span>{{ txt2 }}</span>
        <el-button
          size="mini"
          type="primary"
          style="width: 400px"
          @click="showleTingli"
          >点击选择</el-button
        >
      </el-form-item>
      <!-- <el-form-item label="昨日答案">
        <el-input
          v-model="form.yesterdayAnswer"
          type="textarea"
          autosize
          style="width: 370px"
        />
      </el-form-item> -->
      <!-- <el-form-item label="今日音频">
        <el-link
          v-if="form.todayProblems"
          target="_blank"
          :href="form.todayProblems"
          style="width: 370px; margin-bottom: 10px"
          type="primary"
          >{{ form.todayProblems }}</el-link
        >
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-change="handlePreview1"
          :auto-upload="false"
          accept=".mp3, .MP3, .mp4, .MP4"
          :file-list="fileList1"
        >
          <el-button
            :disabled="audio1"
            :loading="audio1"
            icon="el-icon-upload2"
            size="small"
            :type="buttonType1"
            style="width: 370px"
            >{{ audioText1 }}</el-button
          >
        </el-upload>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="text" @click="cancel">取消</el-button>
      <el-button :loading="loading" type="primary" @click="doSubmit"
        >确认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { add, edit } from "@/api/specifictraining";
import OSS from "ali-oss";
import { getUUID } from "@/utils/uuid";
import { postTable, putTable } from "@/api/table";
import essenceListenss from "./essenceListenss.vue";
export default {
  components: { essenceListenss },
  props: {
    isAdd: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      fileList1: [],
      buttonType1: "primary",
      audio1: false,
      audioText1: "点击上传",

      // fileList2: [],
      // buttonType2: "primary",
      // audio2: false,
      // audioText2: "点击上传",

      // fileList3: [],
      // buttonType3: "primary",
      // audio3: false,
      // audioText3: "点击上传",

      tableIndex: null, //表格

      loading: false,
      dialog: false,
      form: {
        // 种类id
        speciesId: null,
        // 科目名称
        subjectId: "",
        // 昨日答案
        yesterdayAnswer: "",
        //  今日音频
        todayProblems: "",
        // 精听id
        toeflHearingListId: null,
      },
      options1: [],
      options3: [],
      rules: {},
      txt1: "",
      txt2: "",
    };
  },
  methods: {
    // 子组件传参
    returnId(e) {
      console.log(e);
      this.form.toeflHearingListId = e.id;
      this.txt1 = e.cnTitle;
      this.txt2 = e.enTitle;
    },
    // 选择听力精听
    showleTingli() {
      let _this = this.$refs.essenceListenss;
      _this.dialog = true;
    },
    cancel() {
      this.resetForm();
    },
    // 提交
    doSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.isAdd) {
            this.doAdd();
          } else this.doEdit();
        }
      });
    },
    doAdd() {
      postTable(this.tableIndex, this.form)
        .then((res) => {
          this.resetForm();
          this.$notify({
            title: "添加成功",
            type: "success",
            duration: 2500,
          });
          this.loading = false;
          this.$parent.init();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err.response.data.message);
        });
    },
    doEdit() {
      putTable(this.tableIndex, this.form)
        .then((res) => {
          this.resetForm();
          this.$notify({
            title: "修改成功",
            type: "success",
            duration: 2500,
          });
          this.loading = false;
          this.$parent.init();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    resetForm() {
      this.dialog = false;
      this.$refs["form"].resetFields();
      this.form = {
        // 种类id
        speciesId: null,
        // 科目名称
        subjectId: "",
        // 昨日答案
        yesterdayAnswer: "",
        //  今日音频
        todayProblems: "",
        toeflHearingListId: "",
      };
      this.txt1 = "";
      this.txt2 = "";
    },
  // 
    handlePreview1(e) {
      this.fileList1 = [];
      this.fileList1.push({ name: e.name });
      this.ossAudioPut(e.raw, e.size, 1);
    },
    // handlePreview2(e) {
    //   this.fileList2 = [];
    //   this.fileList2.push({ name: e.name });
    //   this.ossAudioPut(e.raw, e.size, 2);
    // },
    // handlePreview3(e) {
    //   this.fileList3 = [];
    //   this.fileList3.push({ name: e.name });
    //   this.ossAudioPut(e.raw, e.size, 3);
    // },

    async ossAudioPut(file, name, index) {
      let client = new OSS({
        region: "oss-cn-qingdao",
        accessKeyId: "LTAI4FnwTeoAmdGYHhJhZVTb",
        accessKeySecret: "pllurUCqkw5O4XxETNXnQg12mC5vQS",
        bucket: "jingjingliuxue",
      });
      this.audio = true;
      this.audioText = "正在拼命加载";
      this.loading = true;
      try {
        await client
          .put(`specialTraining/${getUUID()}${name}`, file)
          .then((e) => {
            this.form.todayProblems = e.url;
            this.audio1 = false;
            this.audioText1 = "已加载完毕, (点击重新选择)";
            this.buttonType1 = "success";
            this.loading = false;
            this.$message({
              message: "音频加载完毕",
              type: "success",
            });
          });
      } catch (e) {
        console.log(e);
        this.audio1 = false;
        // this.audio2 = false;
        // this.audio3 = false;
        this.loading = false;
        this.$message({
          message: "音频加载失败",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped>
.r {
  display: block;
  width: 400px;
}
.r > span {
  font-weight: bold;
}
</style>
